import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=723c2f74&scoped=true"
import script from "./marketing.vue?vue&type=script&lang=js"
export * from "./marketing.vue?vue&type=script&lang=js"
import style0 from "./marketing.vue?vue&type=style&index=0&id=723c2f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c2f74",
  null
  
)

export default component.exports